export const STANDALONE_USAGE_SOURCE = "Standalone";
export const TASK_USAGE_SOURCE = "Task";

export const isStandaloneUsageSource = (source) =>
	source === STANDALONE_USAGE_SOURCE;

export const isEditableUsageSource = (source) =>
	source === STANDALONE_USAGE_SOURCE || source === TASK_USAGE_SOURCE;

/** Returns Task/Timesheet label, or null when usage is standalone. */
export const formatLinkedUsageSource = (source) =>
	isStandaloneUsageSource(source) ? null : source || null;
